// Plan names repeat across records. Pick the record before loading its plans.
(function () {
    function updateApply() {
        var form = document.getElementById('task-plan-filter-form');
        var button = document.querySelector('[data-plan-filter-apply]');
        if (form && button) {
            var noPlan = document.getElementById('plan-filter-standalone').checked;
            document.querySelector('[data-plan-filter-selection]').hidden = noPlan;
            document.querySelector('[data-plan-filter-no-plan]').hidden = !noPlan;
            form.querySelector('[data-no-plan-value]').disabled = !noPlan;
            Array.from(form.elements).forEach(function (el) {
                if (el.name === 'plan' && el.type === 'radio') el.disabled = noPlan;
            });
            button.disabled = !noPlan && !Array.from(form.elements).some(function (el) {
                return el.name === 'plan' && el.type === 'radio' && el.checked;
            });
        }
    }

    function loadPlans(picker) {
        document.getElementById('task-plan-filter-options').replaceChildren();
        updateApply();
        window.htmx.trigger(picker, 'planFilterChanged');
    }

    // The filter bar survives result swaps: read its current values at click time.
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-task-plan-filter-open]');
        if (!trigger) return;
        var params = new URLSearchParams(new FormData(document.getElementById('task-filter-form')));
        var mine = new URLSearchParams(window.location.search).get('mine');
        if (mine) params.set('mine', mine);
        trigger.setAttribute('data-sheet', trigger.getAttribute('data-sheet').split('?')[0] + '?' + params);
    }, true);

    document.addEventListener('change', function (e) {
        var picker = e.target.closest('[data-task-plan-picker]');
        if (picker && e.target.name === 'kind') {
            // Replace the typeahead so responses for the previous type cannot
            // populate the new type's menu.
            var old = picker.querySelector('.typeahead');
            var fresh = old.cloneNode(true);
            fresh.querySelectorAll('input').forEach(function (input) { input.value = ''; });
            fresh.querySelector('.typeahead-results').replaceChildren();
            fresh.querySelector('.typeahead-results').classList.remove('show');
            fresh.setAttribute('data-typeahead-url', fresh.dataset.planSearchUrl + '?kind=' + e.target.value);
            old.replaceWith(fresh);
            picker.querySelector('[data-plan-filter-search]').hidden = e.target.value === 'none';
            picker.elements.plan.value = '';
            loadPlans(picker);
        }
        if (e.target.name === 'plan' || e.target.name === 'plan_mode') updateApply();
    });

    document.addEventListener('typeahead:select', function (e) {
        var picker = e.target.closest('[data-task-plan-picker]');
        if (!picker) return;
        picker.elements.plan.value = '';
        loadPlans(picker);
    });

    document.addEventListener('input', function (e) {
        var picker = e.target.closest('[data-task-plan-picker]');
        if (!picker || !e.target.matches('.typeahead-input')) return;
        if (picker.elements.related_to_label.value) {
            picker.elements.related_to.value = '';
            picker.elements.related_to_label.value = '';
            picker.elements.plan.value = '';
            loadPlans(picker);
        }
    });

    document.addEventListener('submit', function (e) {
        if (e.target.matches('[data-task-plan-picker]')) e.preventDefault();
    });
    document.body.addEventListener('htmx:afterSwap', updateApply);
    document.addEventListener('sheet:ready', updateApply);
})();
